import {
    addressService
} from '../service/addressService';

const address = {
    namespaced: true,
    state: {
        items: []
    },
    mutations: {
        applyPostCodes(state, data) {
            state.items = data;
        },
        resetList(state) {
            state.items = [];
        }
    },
    actions: {
        async lookupPostcode({
            commit
        }, postcode) {
            const addresses = await addressService.lookup(postcode.toUpperCase().replace(' ', ''));
            console.log(addresses);
            commit('applyPostCodes', addresses.map(v => {
                return {
                    label: v.line_1.concat(', ').concat(v.town),
                    address: {
                        address1: v.line_1,
                        address2: v.line_2,
                        city: v.town,
                        postcode: v.postcode
                    }
                }
            }))
        },
        resetList({
            commit
        }) {
            commit('resetList');
        }
    }
}

export default address;